module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/ts/Apps/CategoryBrowsing/src/app/app.component.html
// module id = ./src/ts/Apps/CategoryBrowsing/src/app/app.component.html
// module chunks = main